import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-leftpanel',
  templateUrl: './custom-leftpanel.component.html',
  styleUrls: ['./custom-leftpanel.component.css']
})
export class CustomLeftpanelComponent {

}
